import type { AddressComponents } from '#/utils/googleAddresses';

export const getCity = (addressComponents: AddressComponents) =>
  addressComponents.locality ??
  addressComponents.postal_town ??
  addressComponents.sublocality_level_1 ??
  addressComponents.administrative_area_level_3 ??
  addressComponents.administrative_area_level_2;
